import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {z} from 'zod';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {ContentCardScratchpadState} from '../../scratchpad/contentCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {contentFeedsApi} from 'common/src/modules/contentFeeds/contentFeeds.api';

const inputSchema = z.object({
  searchQuery: z.string().describe('The search query for finding feed columns'),
});

async function execute(
  params: ToolExecuteParams<typeof inputSchema, ContentCardScratchpadState>,
): Promise<ToolResult> {
  const {
    toolUtils: {agentScratchpad},
  } = params;
  const validatedScratchpad = validateAgentScratchpad<ContentCardScratchpadState>(
    agentScratchpad,
    NodeType.CONTENT_FEED,
  );

  const signals = await contentFeedsApi.getFeedSignals(validatedScratchpad.card.contentFeedId);
  validatedScratchpad.card.availableFeedColumns = signals;

  return toolResult(JSON.stringify({columns: validatedScratchpad.card.availableFeedColumns}));
}

export default function searchContentFeedColumnsTool() {
  return tool({
    name: V2CardAgentToolName.SearchContentFeedColumns,
    displayName: 'Searching for content feed columns',
    description: 'Search for content feed columns to use in matching conditions',
    inputSchema,
    execute,
  });
}
